interface OrderConfirmationProps {
  success: boolean;
  orderNumber?: string;
  paymentMethod: 'STRIPE' | 'RAMBURS';
  error?: string;
  onClose: () => void;
  onRetryPayment?: () => void;
}

export function OrderConfirmation({
  success,
  orderNumber,
  paymentMethod,
  error,
  onClose,
  onRetryPayment
}: OrderConfirmationProps) {
  return (
    <div className="text-center space-y-6">
      {success ? (
        <>
          <div data-testid="status-icon" className="w-16 h-16 mx-auto bg-green-500 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-white">
            Comandă plasată cu succes!
          </h3>
          {orderNumber && (
            <p className="text-gray-400">
              Număr comandă: <span data-testid="order-number" className="text-white">{orderNumber}</span>
            </p>
          )}
          <div className="text-gray-300 space-y-2">
            {paymentMethod === 'RAMBURS' ? (
              <>
                <p>Vei primi un email cu detaliile comenzii.</p>
              </>
            ) : (
              <>
                <p>Plata a fost procesată cu succes.</p>
                <p>Vei primi un email cu factura și detaliile comenzii.</p>
              </>
            )}
          </div>
        </>
      ) : (
        <>
          <div data-testid="status-icon" className="w-16 h-16 mx-auto bg-red-500 rounded-full flex items-center justify-center">
            <svg
              className="w-8 h-8 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-white">
            A apărut o eroare!
          </h3>
          <p className="text-gray-300">
            {error || 'Ne cerem scuze, dar comanda nu a putut fi procesată. Te rugăm să încerci din nou.'}
          </p>
        </>
      )}

      <div className="pt-6 space-x-4">
        {!success && paymentMethod === 'STRIPE' && onRetryPayment ? (
          <>
            <button
              onClick={onRetryPayment}
              className="bg-gradient-to-r from-red-600 to-red-700 text-white px-8 py-3 rounded-md 
                hover:from-red-700 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-red-500"
            >
              Încearcă plata din nou
            </button>
            <button
              onClick={onClose}
              className="bg-gray-800 text-white px-8 py-3 rounded-md 
                hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Anulează
            </button>
          </>
        ) : (
          <button
            onClick={onClose}
            className="bg-gradient-to-r from-red-600 to-red-700 text-white px-8 py-3 rounded-md 
              hover:from-red-700 hover:to-red-800 focus:outline-none focus:ring-2 focus:ring-red-500"
          >
            {success ? 'Închide' : 'Încearcă din nou'}
          </button>
        )}
      </div>
    </div>
  );
}
